import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";

const ImageService = {};
ImageService.generateSingleImageUrl = function (data, params) {
  console.warn(params);
  // const formData = Utils.toFormData(data);
  return fetch({
    url: ApiConstant.GENERATE_PRESIGNED_URL,
    method: "POST",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};

ImageService.getGenericR2ContentList = function (params) {
  return fetch({
    url: ApiConstant.GENERIC_R2_CONTENT_LIST_URL,
    method: "GET",
    params: Utils.filterHeaderParams(params),
  });
};
ImageService.editGenericR2Content = function (params, data) {
  return fetch({
    url: ApiConstant.GENERIC_R2_CONTENT_EDIT_URL,
    method: "POST",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};
ImageService.deletGenericR2Content = function (params, data) {
  return fetch({
    url: ApiConstant.GENERIC_R2_CONTENT_DELETE_URL,
    method: "POST",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};

// Fire-and-forget: report direct-to-R2 upload timings so the server log can
// show what the browser saw (duration, status, Cloudflare data centre).
ImageService.uploadTelemetry = function (data) {
  return fetch({
    url: ApiConstant.UPLOAD_TELEMETRY,
    method: "POST",
    data: data,
  });
};

export default ImageService;
